import htmlForPrinting from 'utils/htmlForPrinting';
import { formatDateTime } from '../../shared/utility/dateFormatter';

export const escapeHtml = (value) => {
  if (value === null || value === undefined) return '';

  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

export const renderDate = (params) => (params.value ? formatDateTime(params.value) : '');

export const geocodeAddress = (address) =>
  new Promise((resolve) => {
    if (!address || !window.google?.maps) {
      resolve(null);
      return;
    }

    new window.google.maps.Geocoder().geocode({ address }, (results, status) => {
      if (status !== 'OK' || !results?.[0]) {
        resolve(null);
        return;
      }

      const location = results[0].geometry.location;
      resolve({ lat: location.lat(), lng: location.lng() });
    });
  });

export const buildZoneDetailPrintHtml = (viewTarget, detailFields) => {
  const title = `${viewTarget.ZoneCode} - ${viewTarget.Description || ''}`;
  const tableHtml = `
    <h4>${escapeHtml(title)}</h4>
    <table>
      <tbody>
        ${detailFields
          .map(
            ({ field, label }) =>
              `<tr><th>${escapeHtml(label)}</th><td>${escapeHtml(viewTarget[field])}</td></tr>`
          )
          .join('')}
      </tbody>
    </table>
  `;

  return htmlForPrinting(tableHtml, title);
};
